module.exports = __webpack_public_path__ + "img/DINERS_200x120.044b4936.jpg";